import React, { useState, useEffect } from "react";
import { ReactComponent as InfoIcon } from "../../../../../../assets/fi-rr-info.svg";
import CustomDate from "../../../../../../components/customDate/CustomDate";
import CustomSelect from "../../../../../../components/customSelect/CustomSelect";
import CustomFile from "../../../../../../components/customFile/CustomFile";
import CustomInput from "../../../../../../components/customInput/CustomInput";
import CustomButton from "../../../../../../components/CustomButton";
import { Group, Modal, Radio } from "@mantine/core";
import { useForm } from "react-hook-form";
import { Link, useNavigate } from "react-router-dom";
import { Col, Row, Button } from "reactstrap";
import { Controller } from "react-hook-form";
import AgreementModal from "../../../../../fileClaim/AgreementModal";
import DocuSignModal from "../../../../../fileClaim/DocuSignModal";
import PowerContent from "../../../../../fileClaim/PowerContent";
import { ReactComponent as FlyClaimIcon } from "../../../../../../assets/header button.svg";
import { ReactComponent as Avatar } from "../../../../../../assets/Avatar.svg";
import { ReactComponent as DocumentIcon } from "../../../../../../assets/Document.svg";
import ViewFileModal from "../../../../../../components/Modals/ViewFileModal.js";
import attachmenturl from "../../../../../../api/attachmenturl";

const Attorneynotes = ({
  onSubmit,
  setStepsix,
  isTermsChecked,
  handleTermsChange,
  handleTermsLinkClick,
  isAgreementChecked,
  handleCheckAgreement,
  handleAgreementChange,
  openAgreementModal,
  openPowerOfAttorneyModal,
  handlePowerOfAttorneyChange,
  handleCheckPowerOfAttorney,
  signatureCaptured,
  isPowerOfAttorneyChecked,
  familyMembers,
  pdfBlob,
  poaPdf,
  isAgreementModalOpen,
  closeAgreementModal,
  handleSignatureAdded,
  handlePdfGenerated,
  setEnvelopeId,
  envolpeId,
  setIsDocusignModalOpen,
  signUrl,
  setSignUrl,
  setIsFetching,
  setDocumentFetched,
  activeTab,
  dataToStore,
  isDocuSignModalOpen,
  handleIframeClose,
  powerRef,
  previousNote,
  isPowerOfAttorneyFetchedErrorModal
}) => {
  const options = ["hii", "hello"];
  const [value, setValue] = useState("");
  const [checkboxes, setCheckboxes] = useState({
    terms: false,
    agreement: false,
    powerOfAttorney: false,
  });

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: {
      note: "", // Initialize with empty string
    },
  });

  const [imageModalOpen, setImageModalOpen] = useState(false);
  const [imageModalTitle, setImageModalTitle] = useState("");
  const [imageModalFileUrl, setImageModalFileUrl] = useState("");

  const [showAll, setShowAll] = useState(false);
  const notesToShow = previousNote
    ? showAll
      ? previousNote
      : previousNote.slice(0, 4)
    : [];

  // Enable/disable next button based on checkbox states
  useEffect(() => {
    const allChecked =
      isTermsChecked &&
      isAgreementChecked &&
      (familyMembers.length > 0 ? isPowerOfAttorneyChecked : true);
    setStepsix(allChecked);
    console.log("67----->", allChecked);
  }, [
    isAgreementChecked,
    isTermsChecked,
    setStepsix,
    isPowerOfAttorneyChecked,
  ]);

  const handleFormSubmit = (data) => {
    onSubmit(data);
  };

  const isImageFile = (url) => {
    return /\.(jpeg|jpg|png|gif)$/i.test(url);
  };

  const openImageViewModal = (title, fileUrl) => {
    setImageModalTitle(title);
    setImageModalFileUrl(fileUrl);
    setImageModalOpen(true);
  };
  const closeImageModal = () => {
    setImageModalOpen(false);
  };

  const handleViewFile = (url) => {
    if (!url) {
      return;
    }

    const fileUrl = attachmenturl + url;
    if (!isImageFile(fileUrl)) {
      window.open(fileUrl, "_blank");
    } else {
      openImageViewModal("View File", fileUrl);
    }
  };

  console.log("83--------->", isAgreementChecked);

  return (
    <div className="stepper-container">
      {dataToStore && (
        <PowerContent ref={powerRef} agreementDetails={dataToStore} />
      )}

      <div className="stepper-header-container">
        <h3 className="stepper-header" style={{ margin: 0 }}>
          Attorney notes & submission
        </h3>
      </div>
      {previousNote && previousNote.length > 0 && (
        <div>
          <div className="stepper-header-container">
            <h3 className="stepper-sub-header w-100">
              Previous Notes ({previousNote?.length ?? 0})
            </h3>
            {previousNote.length > 4 && (
              <CustomButton
                btnText={showAll ? "Show Less" : "Show More"}
                color="primary"
                onClick={() => setShowAll((prev) => !prev)}
                className="mt-3 mb-3"
                style={{
                  padding: "6px 16px",
                  maxWidth: "fit-content",
                  whiteSpace: "nowrap",
                }}
                type="secondary"
              />
            )}
          </div>
          <div
            className="mobile-dashboard-comments"
            style={{ margin: "-10px 0 0" }}
          >
            {notesToShow &&
              notesToShow.map((note, index) => (
                <div
                  className="comment-box-wrapper"
                  key={index}
                  style={{
                    backgroundColor: index % 2 === 0 ? "#EFF3F9" : "#fff",
                    padding: "10px 12px",
                  }}
                >
                  <div className="comment-box-header-wrapper">
                    <div className="comment-name-wrapper">
                      {note.user === "customer" ? <Avatar /> : <FlyClaimIcon />}

                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                        }}
                      >
                        <span className="name">
                          {note.user.charAt(0).toUpperCase() +
                            note.user.slice(1)}
                        </span>
                        <span className="designation">{note.timestamp}</span>
                      </div>
                    </div>
                  </div>
                  <div
                    style={{ margin: "6px 8px" }}
                    className="comment-text-box"
                  >
                    <p style={{ margin: "0px" }}>{note.note}</p>
                  </div>
                  {note?.files && note?.files.length > 0 && (
                    <div className="edit-claim-note-files-container">
                      {note?.files?.map((fileUrl, index) => {
                        if (!fileUrl) return null;
                        const fileName = fileUrl?.split("/").pop();
                        const shortenedName =
                          fileName.length > 20
                            ? `${fileName.slice(0, 20)}...`
                            : fileName;
                        return (
                          <div
                            onClick={() => handleViewFile(fileUrl)}
                            key={index}
                            className="edit-claim-note-files"
                          >
                            <DocumentIcon style={{ marginRight: 8 }} />
                            {shortenedName}
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>
              ))}
          </div>
        </div>
      )}

      <div>
        <h4 className="stepper-sub-header" style={{ margin: "20px 0 5px" }}>
          Explain your claim in detail (for attorneys) (optional)
        </h4>
      </div>
      <form
        onSubmit={handleSubmit(handleFormSubmit)}
        className="attorney-notes"
        id="attorney-notes-form"
      >
        <div style={{ display: "flex", flexDirection: "column", gap: "35px" }}>
          <div className="file-a-claim">
            <Controller
              name="note"
              control={control}
              render={({ field }) => (
                <textarea
                  {...field}
                  rows={10}
                  className="textarea-wrapper"
                  placeholder="Please provide additional case details if needed"
                />
              )}
            />
            <div>
              <div
                className="d-flex flex-column justify-content-start "
                style={{ marginTop: "15px", gap: "10px" }}
              >
                <div className="attorney-notes-checkbox-input-container">
                  <input
                    type="checkbox"
                    className="form-check-input attorney-notes-checkbox-input"
                    id="termsCheckbox"
                    checked={isTermsChecked}
                    onChange={handleTermsChange}
                  />
                  <label
                    className="form-check-label mt-2"
                    htmlFor="termsCheckbox"
                    style={{ marginLeft: "12px" }}
                  >
                    I agree to the{" "}
                    <a
                      href="https://api.linsoatours.com/Images/other_document/FLT_Airline_claims_-_TC_1.pdf"
                      target="_blank"
                      onClick={handleTermsLinkClick}
                    >
                      Terms and Conditions
                    </a>
                  </label>
                </div>
                <div className="attorney-notes-checkbox-input-container mobile-attorney">
                  <input
                    type="checkbox"
                    className="form-check-input  attorney-notes-checkbox-input"
                    id="agreementCheckbox"
                    checked={isAgreementChecked}
                    onChange={(e) => {
                      if (handleCheckAgreement()) {
                        handleAgreementChange(e);
                      }
                    }}
                  />
                  <label
                    className="form-check-label mt-2"
                    htmlFor="agreementCheckbox"
                    style={{ marginLeft: "12px" }}
                  >
                    I agree to the{" "}
                    <Link
                      onClick={() => {
                        if (handleCheckAgreement()) {
                          openAgreementModal();
                        }
                      }}
                    >
                      Agreement
                    </Link>
                  </label>
                  {signatureCaptured && (
                    <button
                      type="button"
                      onClick={() => {
                        if (pdfBlob) {
                          const url = URL.createObjectURL(pdfBlob);
                          window.open(url, "_blank");
                        }
                      }}
                      className="view-btn"
                    >
                      <span>
                        <svg
                          width="18px"
                          height="18px"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                          <g
                            id="SVGRepo_tracerCarrier"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          ></g>
                          <g id="SVGRepo_iconCarrier">
                            {" "}
                            <path
                              d="M3.27489 15.2957C2.42496 14.1915 2 13.6394 2 12C2 10.3606 2.42496 9.80853 3.27489 8.70433C4.97196 6.49956 7.81811 4 12 4C16.1819 4 19.028 6.49956 20.7251 8.70433C21.575 9.80853 22 10.3606 22 12C22 13.6394 21.575 14.1915 20.7251 15.2957C19.028 17.5004 16.1819 20 12 20C7.81811 20 4.97196 17.5004 3.27489 15.2957Z"
                              stroke="#fff"
                              stroke-width="1.5"
                            ></path>{" "}
                            <path
                              d="M15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12Z"
                              stroke="#fff"
                              stroke-width="1.5"
                            ></path>{" "}
                          </g>
                        </svg>
                      </span>
                      View Agreement
                    </button>
                  )}
                </div>
                {familyMembers.length > 0 && (
                  <div className="attorney-notes-checkbox-input-container mobile-attorney">
                    <input
                      type="checkbox"
                      className="form-check-input attorney-notes-checkbox-input"
                      id="powerOfAttorneyCheckbox"
                      checked={isPowerOfAttorneyChecked}
                      onChange={(e) => {
                        if (handleCheckPowerOfAttorney()) {
                          handlePowerOfAttorneyChange(e);
                        }
                      }}
                    />
                    <label
                      className="form-check-label mt-2"
                      htmlFor="powerOfAttorneyCheckbox"
                      style={{ marginLeft: "12px" }}
                    >
                      I agree to the{" "}
                      <Link
                        onClick={() => {
                          if (handleCheckPowerOfAttorney()) {
                            openPowerOfAttorneyModal();
                          }
                        }}
                      >
                        Power of Attorney
                      </Link>
                    </label>
                    {poaPdf !== null && (
                      <button
                        type="button"
                        onClick={() => {
                          if (poaPdf) {
                            const url = URL.createObjectURL(poaPdf);
                            window.open(url, "_blank");
                          }
                        }}
                        className="view-btn"
                      >
                        <span>
                          <svg
                            width="18px"
                            height="18px"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                            <g
                              id="SVGRepo_tracerCarrier"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            ></g>
                            <g id="SVGRepo_iconCarrier">
                              {" "}
                              <path
                                d="M3.27489 15.2957C2.42496 14.1915 2 13.6394 2 12C2 10.3606 2.42496 9.80853 3.27489 8.70433C4.97196 6.49956 7.81811 4 12 4C16.1819 4 19.028 6.49956 20.7251 8.70433C21.575 9.80853 22 10.3606 22 12C22 13.6394 21.575 14.1915 20.7251 15.2957C19.028 17.5004 16.1819 20 12 20C7.81811 20 4.97196 17.5004 3.27489 15.2957Z"
                                stroke="#fff"
                                stroke-width="1.5"
                              ></path>{" "}
                              <path
                                d="M15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12Z"
                                stroke="#fff"
                                stroke-width="1.5"
                              ></path>{" "}
                            </g>
                          </svg>
                        </span>
                        View POA
                      </button>
                    )}
                  </div>


                )}

                {/* {
                  familyMembers.length > 0 && <p className="note-wrapper">
                    Please print and have all signatures completed. Email back document to <a href="mailto:claims@flyandclaim.com">claims@flyandclaim.com
                    </a> or access your claim from our website to sign the documents electronically.
                  </p>
                } */}
              </div>
              <AgreementModal
                isOpen={isAgreementModalOpen}
                onRequestClose={closeAgreementModal}
                onSignatureAdded={handleSignatureAdded}
                onPdfGenerated={handlePdfGenerated}
                setEnvelopeId={setEnvelopeId}
                envolpeId={envolpeId}
                signUrl={signUrl}
                setSignUrl={setSignUrl}
                setIsDocusignModalOpen={setIsDocusignModalOpen}
                setIsFetching={setIsFetching}
                setDocumentFetched={setDocumentFetched}
                agreementDetails={dataToStore}
                activeTab={activeTab}
              />

            

              
              
              
              {/* <PowerModal
                isOpen={isPowerModalOpen}
                onRequestClose={closePowerModal}
                agreementDetails={dataToStore}
                activeTab={activeTab}
              /> */}
              <DocuSignModal
                isOpen={isDocuSignModalOpen}
                onRequestClose={() => setIsDocusignModalOpen(false)}
                signUrl={signUrl}
                setSignUrl={setSignUrl}
                handleIframeClose={handleIframeClose}
              />

              <ViewFileModal
                isOpen={imageModalOpen}
                closeModal={closeImageModal}
                modalTitle={imageModalTitle}
                modalFileUrl={imageModalFileUrl}
              />
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

export default Attorneynotes;
